import { Typography } from '@cockpitai/components/atoms/Typography'
import {
  TAlertCondition,
  TAlertNotifyItem,
} from '@cockpitai/integration/notification/types'
import { arrowDirection } from '@cockpitai/integration/panels/types'
import { useChatStore } from '@cockpitai/store/chat'
import { memo } from 'react'
import { SectionListItem } from './SectionListItem'

export type TSectionListItem = {
  id: number
  title: string
  description?: string
  refData?: string
  indicator?: {
    arrow: arrowDirection
  }
  value?: number
  condition?: TAlertCondition
  target_month?: string
  read?: boolean
  notify?: TAlertNotifyItem[]
}

type TSectionListProps = {
  title: string
  items: TSectionListItem[]
  isNotification?: boolean
  isAlert?: boolean
  onClick(historyChatId: number): void
}

export const SectionList = memo(
  ({
    title,
    items,
    isNotification = false,
    isAlert = false,
    onClick,
  }: TSectionListProps) => {
    const { historyChatId } = useChatStore()

    return items.length > 0 ? (
      <>
        <Typography
          type="bodyOne"
          weight="medium"
          className="sticky top-0 bg-solid px-2 pb-2 text-white/75">
          {title}
        </Typography>
        {items.map((item) => {
          return (
            <SectionListItem
              active={historyChatId === item.id}
              key={item.id}
              {...item}
              isAlert={isAlert}
              isNotification={isNotification}
              onClick={() => onClick(item.id)}
            />
          )
        })}
      </>
    ) : (
      <></>
    )
  },
)
